import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({
  currentPage, // 0-based index
  totalCount,
  pageSize,
  fetchData,
  loading,
  paginationFor = "jobs",
  conatinerId = "",
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const currentPageForUI = currentPage + 1; // frontend shows 1-based

  if (totalPages <= 1) return null;

  // Derived indexes for results info
  const startIndex = currentPage * pageSize;
  const endIndex = Math.min((currentPage + 1) * pageSize, totalCount);

  const goToPage = (pageOneBased) => {
    const apiPage = pageOneBased - 1;
    if (conatinerId) {
      document
        .getElementById(conatinerId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
    fetchData(apiPage);
  };

  return (
    <div className="pagination">
      {/* Results Info */}
      <div className="pagination-info">
        Showing{" "}
        <span className="tw-font-semibold">
          {startIndex + 1}-{endIndex}
        </span>{" "}
        of <span className="tw-font-semibold">{totalCount}</span>{" "}
        {paginationFor}
      </div>

      {/* Pagination Controls */}
      <div className="tw-flex tw-items-center tw-space-x-2">
        {/* Previous */}
        <button
          onClick={() => goToPage(currentPageForUI - 1)}
          disabled={currentPage === 0 || loading}
          className={`pagination-nav-btn ${
            currentPage === 0
              ? "pagination-nav-btn-disabled"
              : "pagination-nav-btn-enabled"
          }`}
        >
          <ChevronLeft className="tw-h-4 tw-w-4 tw-mr-1" />
          Previous
        </button>

        {/* Page Numbers */}
        <div className="pagination-numbers">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
            const showPage =
              page === 1 ||
              page === totalPages ||
              (page >= currentPageForUI - 1 && page <= currentPageForUI + 1);

            if (
              !showPage &&
              page !== currentPageForUI - 2 &&
              page !== currentPageForUI + 2
            )
              return null;

            if (
              (page === currentPageForUI - 2 && currentPageForUI > 3) ||
              (page === currentPageForUI + 2 &&
                currentPageForUI < totalPages - 2)
            ) {
              return (
                <span key={page} className="pagination-ellipsis">
                  ...
                </span>
              );
            }

            return (
              <button
                key={page}
                onClick={() => {
                  if (currentPageForUI != page) {
                    goToPage(page);
                  }
                }}
                className={`pagination-btn ${
                  currentPageForUI === page
                    ? "pagination-btn-active"
                    : "pagination-btn-inactive"
                }`}
              >
                {page}
              </button>
            );
          })}
        </div>

        {/* Next */}
        <button
          onClick={() => goToPage(currentPageForUI + 1)}
          disabled={currentPageForUI === totalPages || loading}
          className={`pagination-nav-btn  ${
            currentPageForUI === totalPages
              ? "pagination-nav-btn-disabled"
              : "pagination-nav-btn-enabled"
          }`}
        >
          Next
          <ChevronRight className="tw-h-4 tw-w-4 tw-ml-1" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
